import Super from 'client-portal/routes/-request/prescreener-billing-payment';

export default class SiteRequestPrescreenerBillingPayment extends Super {}
